import { render, staticRenderFns } from "./Thanas.vue?vue&type=template&id=0f927382&scoped=true&"
import script from "./Thanas.vue?vue&type=script&lang=js&"
export * from "./Thanas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f927382",
  null
  
)

export default component.exports